import { createContext, useContext } from 'libs/react';
import { React, useState } from 'libs/react';
import { useCallback } from 'react';
const DocumentationPanelContext = createContext({
    isOpen: false,
    openPanel: () => { },
    closePanel: () => { }
});
/**
 * @function useDocumentationPanel
 * @since 2.0.0
 * Hook pour ouvrir/fermer le panneau de documentation depuis n'importe quel écran
 */
export function useDocumentationPanel() {
    return useContext(DocumentationPanelContext);
}
/**
 * @component DocumentationPanelProvider
 * @since 2.0.0
 * Provider global à placer dans MainLayout
 */
export function DocumentationPanelProvider(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [module, setModule] = useState();
    const [tag, setTag] = useState();
    const [articleId, setArticleId] = useState();
    const openPanel = useCallback((options) => {
        setModule(options === null || options === void 0 ? void 0 : options.module);
        setTag(options === null || options === void 0 ? void 0 : options.tag);
        setArticleId(options === null || options === void 0 ? void 0 : options.articleId);
        setIsOpen(true);
    }, []);
    const closePanel = useCallback(() => {
        setIsOpen(false);
    }, []);
    return (React.createElement(DocumentationPanelContext.Provider, { value: { isOpen, module, tag, articleId, openPanel, closePanel } }, props.children));
}
